import * as React from 'react'
import { Button } from '@mobiscroll/react-latest'
import { OrganizationTeamMemberDisplayStatuses } from '../../../constants/organization-team-member-statuses'
import ArchiveIcon from '../../icons/ui/Archive'
import Edit from 'src/components/icons/drivers/Edit'
import SendInvite from '../../icons/ui/SendInvite'
import UnlockIcon from '../../icons/ui/Unlock'
import EntityHeaderTitle from '../../ui/entity/EntityHeaderTitle'
import { IMemberSearchObject } from 'src/types/team-member'
import { handleRedirect } from 'src/utils'
import UIMessages from 'src/utils/ui-messages'

interface ITeamMemberViewHeader {
  isArchived?: boolean
  isFetching?: boolean
  name: string
  status: string
  teamMember: IMemberSearchObject
  onMoveToArchive: () => void
  onResetPassword: () => void
  onSendInvitation: () => void
}

const TeamMemberViewHeader = ({
  isArchived,
  isFetching = false,
  name,
  status,
  teamMember,
  onMoveToArchive,
  onResetPassword,
  onSendInvitation
}: ITeamMemberViewHeader) => {
  const { common, teamMember: teamMemberLabel } = UIMessages
  const { active, archived, edit } = common
  const { moveToArchive, resetPassword, restoreFromArchive, sendInvite } = teamMemberLabel

  const headerButtonMapping = [
    {
      ariaLabel: 'Send invite button',
      btnLabel: sendInvite,
      icon: <SendInvite className='absolute icon--small ml2 svg-fill-white-path z1' />,
      onClick: onSendInvitation
    },
    {
      ariaLabel: 'Reset password button',
      btnLabel: resetPassword,
      icon: <UnlockIcon className='absolute icon--small ml2 svg-fill-white-path z1' />,
      onClick: onResetPassword
    },
    {
      ariaLabel: 'Edit button',
      btnLabel: edit,
      icon: <Edit className='absolute icon--small ml2 svg-fill-white-path z1' />,
      onClick: () => handleRedirect(`/team-members/edit/${teamMember.id}`)
    },
    {
      ariaLabel: 'Archiving button',
      btnLabel: isArchived ? restoreFromArchive : moveToArchive,
      icon: <ArchiveIcon className='absolute icon--small ml2 svg-fill-white-path z1' />,
      onClick: onMoveToArchive
    }
  ]

  return (
    <div className='flex justify-between items-center p2'>
      <div>
        <EntityHeaderTitle>{name}</EntityHeaderTitle>
        <span className='h5 ml2'>
          {`Status: ${
            OrganizationTeamMemberDisplayStatuses[status as keyof typeof OrganizationTeamMemberDisplayStatuses]
          } | ${isArchived ? archived : active}`}
        </span>
      </div>
      <div className='flex'>
        {headerButtonMapping.map(({ ariaLabel, btnLabel, icon, onClick }) => (
          <div className='flex items-center relative' key={ariaLabel}>
            <Button
              ariaLabel={ariaLabel}
              className='mbsc-btn-with-start-icon mbsc-success-btn'
              disabled={isFetching}
              onClick={onClick}
            >
              {btnLabel}
            </Button>
            {icon}
          </div>
        ))}
      </div>
    </div>
  )
}

export default TeamMemberViewHeader



// WEBPACK FOOTER //
// ./src/components/team-members/view/TeamMemberViewHeader.tsx